import { Text, View } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { LocaleIdentifier } from '../../../../../../../../../../types/localeIdentifier'
import { getSalesReportDateRangeLabel } from '../../utils/getSalesReportDateRangeLabel'
import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfHeaderProps {
  documentTitle: string
  endDate: string | undefined
  firstFiscalYearStart: string | undefined
  locale: LocaleIdentifier
  organizationName: string | undefined
  startDate: string | undefined
}

export const SalesReportPdfHeader = ({
  documentTitle,
  endDate,
  firstFiscalYearStart,
  locale,
  organizationName,
  startDate,
}: SalesReportPdfHeaderProps): ReactElement => {
  return (
    <View style={pdfStyles.header}>
      <Text style={pdfStyles.h1}>{documentTitle}</Text>
      <Text style={pdfStyles.subTitle}>{organizationName}</Text>
      <Text style={pdfStyles.dateRange}>
        {getSalesReportDateRangeLabel({ startDate, endDate, locale, firstFiscalYearStart })}
      </Text>
    </View>
  )
}
